import { useQuery } from '@abyss/web/hooks/useQuery';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import DecisionCodes from './DecisionCodes.gql';

export const useDecisionCodes = (options) => {
  return useQuery(DecisionCodes, {
    ...options,
    url: ApiUrl.graphQl(),
  });
};
